import Image from 'next/image';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';

import Carousel from 'react-material-ui-carousel';

import { customLoader } from '../../../utils/customLoaderImage';
import { imagemSizes } from '../../../utils/ImageFindSizes';

import style from './galeryMobileCarousel.module.scss';

export default function GaleryMobileCarousel({ images, objectFit }) {
  if (!images) return null;

  const options = {
    settings: {
      overlayColor: 'rgba(25,136,124,0.71)',
      autoplaySpeed: 3000,
      transitionSpeed: 900,
    },
    buttons: {
      showThumbnailsButton: false,
      showDownloadButton: false,
      showNextButton: true,
      showPrevButton: true,
      showAutoplayButton: false,
    },
    caption: {
      showCaption: false,
      captionColor: '#a6cfa5',
      captionFontFamily: 'Raleway, sans-serif',
      captionFontWeight: '300',
      captionTextTransform: 'uppercase',
    },
    thumbnails: {
      showThumbnails: false,
    },
  };

  const showControls = () => {
    const SRLStage = document.getElementsByClassName('SRLStage')[0];
    const buttons = SRLStage.getElementsByTagName('button');

    for (let i = 0; i < buttons.length; i += 1) {
      if (buttons[i].classList.contains('SRLNextButton') || buttons[i].classList.contains('SRLPrevButton')) {
        buttons[i].style.display = 'block';
        buttons[i].style.marginTop = '40px';
      }
    }
  };

  if (typeof window !== 'undefined') {
    Array.from(document.getElementsByClassName('MuiButtonBase-root')).forEach((element) => {
      const ariaElement = element.getAttribute('aria-label')?.slice(0, 18);

      if (ariaElement && ariaElement === 'carousel indicator') element.setAttribute('tabindex', '-1');
    });
  }

  return (
    <SimpleReactLightbox>
      <SRLWrapper options={options}>
        <Carousel
          navButtonsAlwaysVisible
          autoPlay
          className={style.slider}>
          {images.map((img) => (
            <div
              className={style.slide}
              key={img.id}>
              <figure>
                <Image
                  alt={img.imagem?.titulo}
                  src={imagemSizes(img) || ''}
                  loader={customLoader}
                  layout='responsive'
                  objectFit={objectFit}
                  width='600'
                  height='350'
                  style={{
                    cursor: 'pointer',
                  }}
                  onClick={() => showControls()}
                  priority
                />
                <figcaption>{img.imagem?.titulo}</figcaption>
              </figure>
            </div>
          ))}
        </Carousel>
      </SRLWrapper>
    </SimpleReactLightbox>
  );
}
